export default "__VITE_ASSET__BaHCNCv5__"